import axios from "axios";

const customAxios = axios.create({
    // baseURL: 'http://localhost:8080/api'
    baseURL: 'https://melqonyan-realty.am/api'
});

export default customAxios
